var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-in"}},[(_vm.scrollPosition > 1000 && _vm.scrollDirection === 'up')?_c('div',{staticClass:"back-to-top",on:{"click":_vm.scrollToTop}},[_c('div',{staticClass:"bg"}),_c('div',{staticClass:"arrow"},[_c('div',{staticClass:"wrapper"},[_c('div',[_c('span')]),_c('div',[_c('span')])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }